import { EMPTY_STRING } from '../../constants/common'
import { htmlToPlainText } from '../../utils/html'

import {
  BROWSER_TAB_ERROR_TITLE_BY_STATUS,
  BROWSER_TAB_TITLE_IDWELL,
  BROWSER_TAB_TITLE_MAX_PAGE_TITLE_LENGTH,
  BROWSER_TAB_TITLE_SEPARATOR,
} from './usePageBrowserTabTitle.constants'

export function sanitizePageTitle(value) {
  return htmlToPlainText(String(value ?? EMPTY_STRING))
    .replace(/[\r\n]+/g, ' ')
    .trim()
}

export function clampPageTitle(title) {
  return title.length <= BROWSER_TAB_TITLE_MAX_PAGE_TITLE_LENGTH
    ? title
    : `${title.slice(0, BROWSER_TAB_TITLE_MAX_PAGE_TITLE_LENGTH - 1).trimEnd()}…`
}

export function createTabTitle({ title }) {
  const normalizedPageTitle = clampPageTitle(sanitizePageTitle(title))

  if (normalizedPageTitle) {
    return `${normalizedPageTitle}${BROWSER_TAB_TITLE_SEPARATOR}${BROWSER_TAB_TITLE_IDWELL}`
  }

  return BROWSER_TAB_TITLE_IDWELL
}

export function getTabErrorTitleKey(status) {
  return (
    BROWSER_TAB_ERROR_TITLE_BY_STATUS[status] ||
    (status ? 'BrowserTab.ErrorTextKey' : null)
  )
}

export function getPageBrowserTabTitleWithEntityName({ name, title }) {
  if (!name) {
    return title
  }

  return `${title}: ${name}`
}
